import axios from 'axios'
import {config} from '../Config/config'

const kategori_faskesService = {
    getAll : () => {
        const result = axios.get(config.apiUrl + '/kategori_faskes')
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    addData : (data) => {
        const result = axios.post(config.apiUrl + '/kategori_faskes', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getById : (id) => {
        const result = axios.get(config.apiUrl + '/kategori_faskesById/' + id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getByNama : (nama) => {
        const result = axios.get(config.apiUrl + '/kategori_faskesCek/' + nama)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result[0]
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    EditData : (data) => {
        console.log(data)
        const result = axios.put(config.apiUrl + '/kategori_faskes', data)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    DeleteData : (id) => {
        console.log(id)
        const result = axios.put(config.apiUrl + '/kategori_faskesDelete', id)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    },

    getAllFilter : (filter) => {
        const result = axios.post(config.apiUrl + '/kategori_faskesFilter', filter)
        .then(respon => {
            return{
                success : respon.data.success,
                result : respon.data.result
            }
        })
        .catch(error =>{
            return{
                success : false,
                error : error
            }
        })
        return result
    }
    
}


export default kategori_faskesService